<style>
.zoezi-dialog-title {
    position:relative;
    z-index: 100;

    @media (max-width: 550px) {
        font-size: 0.7em;
    };
    @media (max-width: 300px) {
        font-size: 0.5em;
    };
}
</style>

<template>
    <v-auto-img
        :src="image"
        max-height="30vh"
        min-height="270px"
        class="white--text primary z-fade-dark-bottom-left"
    >
        <div class="d-flex flex-column fill-height">
            <v-btn
                right
                icon @click="$emit('close')"
                class="ml-auto d-flex"
                v-if="showClose"
            >
                <v-icon class="white--text">mdi-close</v-icon>
            </v-btn>
            <v-spacer />
            <div class="px-6 header zoezi-dialog-title">
                <template v-if="$scopedSlots.pretitle">
                    <slot name="pretitle" />
                </template>
                <h1
                    class="text--shadow-large mb-2"
                    v-text="title"
                />
            </div>
        </div>
    </v-auto-img>
</template>

<script>
export default {
    name: 'zoezi-dialog-header',

    props: {
        image: {
            type: String
        },
        title: {
            type: String
        },
        showClose: {
            type: Boolean,
            default: true
        }
    }
}
</script>
